import { render, staticRenderFns } from "./sign-auth.vue?vue&type=template&id=b8ff1556&scoped=true&"
import script from "./sign-auth.vue?vue&type=script&lang=js&"
export * from "./sign-auth.vue?vue&type=script&lang=js&"
import style0 from "./sign-auth.vue?vue&type=style&index=0&id=b8ff1556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff1556",
  null
  
)

export default component.exports